// @flow
import { ImageGalleryItem } from 'components/atoms/imageGalleryItem';
import React from 'react';
import type { GalleryImageType } from 'types/common';
// eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  data: Array<GalleryImageType>,
  onItemClick: (id: number) => void,
};

export const ImageGalleryGrid = (props: Props) => {
  const { data } = props;
  if (!data || data.length === 0) {
    return null;
  }
  return (
    <div className={'image-gallery-grid'}>
      <div className={'grid-column'}>
        {data.length > 0 && (
          <ImageGalleryItem
            imageUrl={data[0].mediumImageUrl}
            thumbnail={data[0].thumbnailMediumImageUrl}
            caption={data[0].caption}
            className={'small-item separator'}
            onClick={() => props.onItemClick(data[0])}
          />
        )}
        {data.length > 1 && (
          <ImageGalleryItem
            imageUrl={data[1].mediumImageUrl}
            thumbnail={data[1].thumbnailMediumImageUrl}
            caption={data[1].caption}
            className={'medium-item'}
            onClick={() => props.onItemClick(data[1])}
          />
        )}
      </div>
      <div className={'grid-column'}>
        {data.length > 2 && (
          <ImageGalleryItem
            imageUrl={data[2].largeImageUrl}
            thumbnail={data[2].thumbnailLargeImageUrl}
            caption={data[2].caption}
            className={'large-item'}
            onClick={() => props.onItemClick(data[2])}
          />
        )}
      </div>
      <div className={'grid-column'}>
        {data.length > 3 && (
          <ImageGalleryItem
            imageUrl={data[3].mediumImageUrl}
            thumbnail={data[3].thumbnailMediumImageUrl}
            caption={data[3].caption}
            className={'medium-item separator'}
            onClick={() => props.onItemClick(data[3])}
          />
        )}
        {data.length > 4 && (
          <ImageGalleryItem
            imageUrl={data[4].mediumImageUrl}
            thumbnail={data[4].thumbnailMediumImageUrl}
            caption={data[4].caption}
            className={'small-item'}
            onClick={() => props.onItemClick(data[4])}
          />
        )}
      </div>
    </div>
  );
};
